<template>
    <form @submit.prevent="pushDeviceAndGoBack">
        <grid class="c-m g-m">
            <row :reverse="!1" center="xs" middle="xs">
                <column :xs="9" :sm-offset="12">
                    <button class="dock-pull-button" @click="$router.push({name:'qr_scan'})"><i class="far fa-qrcode"></i> {{$t('devices.add.scan_qr_label')}}</button>
                </column>
            </row>
            <row class="c-m" :reverse="!1" middle="xs" end="xs">
                <column :xs="3">
                    <b>{{$t('devices.phone_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" :value="device.phone" name="phone" @input="setDevice" type="text">
                </column>
                <column :xs="2"></column>
            </row>
            <row :reverse="!1" class="c-m"  middle="xs" end="xs">
                <column :xs="3">
                    <b>{{$t('devices.imei_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" :value="device.imei" name="imei" @input="setDevice" type="text">
                </column>
                <column :xs="2"></column>
            </row>
            <row :reverse="!1" class="c-m"  middle="xs" end="xs">
                <column :xs="3">
                    <b>{{$t('devices.mode_label')}}</b>
                </column>
                <column :xs="7">
                    <label class="dock-pull-select-label">
                        <select class="dock-pull-select">
                            <option>{{$t('devices.mode.sleep_label')}}</option>
                            <option>{{$t('devices.mode.secure_label')}}</option>
                            <option>{{$t('devices.mode.search_label')}}</option>
                        </select>
                    </label>
                </column>
                <column :xs="2"></column>
            </row>
            <row :reverse="!1" class="c-m"  middle="xs" end="xs">
                <column :xs="3">
                    <b>{{$t('devices.name_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" :value="device.name" name="name" @input="setDevice" type="text">
                </column>
                <column :xs="2"></column>
            </row>
            <row :reverse="!1" class="dpli-h height60" center="xs" middle="xs" @click="$router.push({name:'device_new_options'})">
                <column :xs="2">
                    <i class="far fa-sliders-h fa-2x"></i>
                </column>
                <column :xs="10">
                    <b>{{$t('devices.optional.settings_label')}}</b>
                </column>
            </row>
            <row class="c-m" center="xs">
                <column :xs-offset="12">
                    <button class="dock-pull-button" type="submit">&nbsp;&nbsp;&nbsp;{{$t('devices.add.create_obj_label')}} &nbsp;&nbsp;&nbsp;</button>
                </column>
            </row>
            <row class="c-m" center="xs">
                <column :xs-offset="12">
                    <button class="dock-pull-button">{{$t('devices.add.request_inst_label')}}</button>
                </column>
            </row>
        </grid>
    </form>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'NewDevices',
  computed: {
    ...mapGetters({
      device: 'getAddDevice'
    })
  },
  methods: {
    ...mapMutations(['updateAddDevice']),
    ...mapActions(['pushDevice']),
    setDevice (e) {
      this.updateAddDevice({
        prop: e.target.name,
        value: e.target.value
      })
    },
    pushDeviceAndGoBack (e) {
      this.pushDevice(e)
      this.$router.push({name: 'devices'}) // todo refactor for router in store
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/devices/new/NewDevice.vue